(function () {
  const questions = [
    "1. How would you describe your skin type?",
    "2. What’s your skin craving the most right now?",
    "3. How do you usually feel after sun exposure?",
    "4. How dedicated are you to your skincare routine?",
    "5. Which of these best describes your daily environment?",
    "6. How much water do you drink daily?",
    "7. What’s your biggest skincare goal right now?",
  ];

  const options = [
    [
      {
        text: "Oilier than a fresh slice of pizza 🍕",
        url: "/collections/frontpage",
      },
      { text: "Dry as a winter breeze 🌬️", url: "/collections/frontpage" },
      { text: "A bit of both 🎭", url: "/collections/frontpage" },
      { text: "Happy and balanced 🌸", url: "/collections/frontpage" },
      { text: "Sensitive and shy 🙈", url: "/collections/frontpage" },
    ],
    [
      "Clear skin 🙅‍♀️",
      "Hydration 💦",
      "Smoother, brighter complexion 🌞",
      "A little lift 👋",
      "Less redness!",
    ],
    [
      "Sunburnt 🔥",
      "A healthy glow ☀️",
      "Tanned but uneven 🌚",
      "Red as a lobster 🦞",
    ],
    ["Just the basics 🏃‍♀️", "A few extra steps 🌱", "Give me the works 👑"],
    ["Outdoors 🌇", "Mostly indoors 🏠", "A mix with travel ✈️"],
    ["Not enough 😅", "4-6 glasses", "7-9 glasses", "10+ glasses 💧"],
    [
      "Fewer breakouts",
      "Brighter, even tone 🌟",
      "Bye-bye, fine lines 👋",
      "Glowing, hydrated skin 💧",
      "Smooth and poreless!",
    ],
  ];

  let currentQuestionIndex = 0;
  const userResponses = [];
  let selectedOptionIndex = null;

  // Fetch products from the selected URL in the first question
  async function fetchProducts(url) {
    console.log("Fetching products from:", url);
    try {
      const response = await fetch(url);
      const data = await response.text();
      var parser = new DOMParser(),
        doc = parser.parseFromString(data, "text/html"),
        return_html = doc.body,
        main_html = return_html.querySelector("#product-grid"),
        main_html_child = main_html.querySelectorAll(".grid__item");
      displayProducts(main_html_child);
    } catch (error) {
      console.error("Error fetching products:", error);
      document.getElementById("product-container").innerHTML =
        "<p>Failed to load products. Please try again.</p>";
    }
  }

  // Display fetched products
  function displayProducts(products) {
    const productContainer = document.getElementById("product-container");
    const productsList = document.createElement("ul");
    productsList.id = "product-grid";
    productsList.setAttribute(
      "class",
      "grid product-grid contains-card--standard grid--4-col-desktop grid--2-col-tablet-down"
    );
    products.forEach((product, index) => {
      if (index > 3) return;
      productsList.appendChild(product);
    });
    const proceedToCheckoutButton = document.createElement("button");
    proceedToCheckoutButton.setAttribute("class", "proceed-checkout");
    proceedToCheckoutButton.textContent = "Proceed to Checkout";
    const reTake = document.createElement("a");
    reTake.setAttribute("class", "retake");
    reTake.setAttribute("href", "/pages/skin-analysis");
    reTake.textContent = "Retake";
    toggleLoadingState();
    setTimeout(() => {
      toggleLoadingState();
      hideOtherSections();
      document
        .getElementById("question-container")
        .setAttribute(
          "class",
          "results-container scroll-trigger animate--slide-in"
        );
      document.getElementById("question-container").innerHTML =
        "<h2>Your Personalized Skincare Routine.</h2>";
      productContainer.innerHTML = productsList.outerHTML;
      productContainer.appendChild(proceedToCheckoutButton);
      productContainer.appendChild(reTake);
      proceedToCheckoutButton.addEventListener("click", addProductsToCart);
    }, 2000);
  }

  async function addProductsToCart() {
    toggleLoadingState();
    const variantIds = Array.from(
      document.querySelectorAll("#product-grid .quick-add")
    ).map((product) => Number(product.dataset.id));
    if (variantIds.length === 0) return;
    const items = variantIds.map((id) => ({ id, quantity: 1 }));
    let formData = {
      items: items,
    };
    await fetch('/cart/clear.js');
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        toggleLoadingState();
        window.location.href = "/checkout";
      })
      .catch((error) => {
        toggleLoadingState();
        console.error("Error:", error);
      });
  }

  function hideOtherSections() {
    document.querySelector(".media__banner").parentElement.style =
      "display:none!important";
    document.querySelector(".icons-list").parentElement.style =
      "display:none!important";
  }
  document.querySelector('.banner__btn').addEventListener('click', function() {
    hideOtherSections();
    const content = document.querySelector('.main-quiz');
    content.style.display = 'block';
  });

  function toggleLoadingState() {
    document.documentElement.classList.toggle("active-loading-state");
  }

  function showQuestion() {
    const { question, options: questionOptions } =
      getQuestion(currentQuestionIndex);
    const questionContainer = document.getElementById("question-container");
    questionContainer.innerHTML = `<h2>${question}</h2>`;

    const optionsContainer = document.createElement("div");
    optionsContainer.setAttribute(
      "class",
      "quiz-options scroll-trigger animate--slide-in"
    );
    questionOptions.forEach((option, index) => {
      const button = document.createElement("button");
      button.textContent = typeof option === "object" ? option.text : option;
      button.onclick = () => {
        handleOptionSelect(index);
        handleActiveOption(button);
      };
      button.classList.add("quiz-option");
      optionsContainer.appendChild(button);
    });

    questionContainer.appendChild(optionsContainer);

    const nextButton = document.createElement("button");
    nextButton.className = "next-button";
    nextButton.innerHTML =
      currentQuestionIndex < questions.length - 1
        ? `<span>Next</span><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.9849 9.71753L12.9849 15.7175L6.98486 9.71753" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`
        : "<span>Show Results</span>";

    if (currentQuestionIndex >= questions.length - 1) {
      nextButton.classList.add("show-results");
    }
    nextButton.onclick = handleNextButtonClick;
    questionContainer.appendChild(nextButton);
  }

  function getQuestion(index) {
    return { question: questions[index], options: options[index] };
  }

  function handleOptionSelect(optionIndex) {
    selectedOptionIndex = optionIndex;
  }

  function handleActiveOption(button) {
    const questionButtons = document.querySelectorAll(".quiz-option");
    questionButtons.forEach((btn) => btn.classList.remove("selected"));
    button.classList.add("selected");
  }

  async function handleNextButtonClick() {
    if (selectedOptionIndex === null) {
      alert("Please select an option before proceeding.");
      return;
    }

    const selectedOption = options[currentQuestionIndex][selectedOptionIndex];
    userResponses.push({
      question: questions[currentQuestionIndex],
      selectedOption:
        typeof selectedOption === "object"
          ? selectedOption.text
          : selectedOption,
      url: typeof selectedOption === "object" ? selectedOption.url : null,
    });

    // if (currentQuestionIndex === 0 && typeof selectedOption === 'object') {
    //   await fetchProducts(selectedOption.url);
    // }

    selectedOptionIndex = null;
    currentQuestionIndex++;

    if (currentQuestionIndex < questions.length) {
      showQuestion();
    } else {
      endQuiz();
    }
  }

  async function endQuiz() {
    await fetchProducts(userResponses[0].url);
  }

  document.addEventListener("DOMContentLoaded", showQuestion);
})();
